function transformItem2Dto(item) {
  const dto = {
    code: item.id,
    description: item.description
  };
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    description: dto.description,
    id: dto.code
  };
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
